import React, { Component } from 'react';
import SecureLayout from '../../../templates/secure';
import {NavLink} from 'react-router-dom';
import _ from 'lodash';

class GoalsAdd extends Component{
	render(){
		const {goals} =this.props;
		let gc = _.find(goals.permissions, (o) => {return o==='Create'});
		return (
			gc ?
				<p>
					<NavLink to={`/proigualdad/metas/crear`} className="button is-small is-inm-purple">{'Agregar Meta'}</NavLink>
				</p>:''
		)
	}
}

export default SecureLayout(GoalsAdd);


// WEBPACK FOOTER //
// ./src/elements/goals/widget/goals_add.jsx